var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "manageDocumentTypesModal",
    attrs: {
      id: "manage-document-types-modal",
      "footer-close-button": false,
      "modal-dialog-size": "lg",
    },
    on: { hide: _vm.handleHide },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("documents.manageDocumentTypes")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("documents.useTheAreBellowToManageYourDocumentTypes")
                  ) +
                  ","
              ),
              _c("b", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("documents.youCanClickAnyFieldToEdit"))
                ),
              ]),
            ]),
            _vm._v(" "),
            !_vm.isEmptyData
              ? _c("div", [
                  _c(
                    "table",
                    { staticClass: "table table-hover vue-custom-table" },
                    [
                      _c("thead", { staticClass: "thead" }, [
                        _c("tr", [
                          _c("th", { staticClass: "w-30 VueTables__heading" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("global.words.name")) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "VueTables__heading" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("global.words.description")) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "hidden-heading" }, [
                            _c("span", { staticClass: "VueTables__heading" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("global.words.delete")) +
                                  "\n              "
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "draggable",
                        {
                          key: _vm.nonce,
                          staticClass: "pl-0",
                          attrs: {
                            tag: "tbody",
                            animation: 200,
                            "ghost-class": "ghost",
                            handle: ".dropdown-item-drag-handle",
                          },
                          on: { change: _vm.handleOrder },
                          model: {
                            value: _vm.modelItems,
                            callback: function ($$v) {
                              _vm.modelItems = $$v
                            },
                            expression: "modelItems",
                          },
                        },
                        _vm._l(_vm.modelItems, function (document) {
                          return _c(
                            "tr",
                            {
                              key: document.documentTypeId,
                              staticClass: "VueTables__row",
                            },
                            [
                              _c("td", { staticClass: "w-30" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-row" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "mr-1 dropdown-item-drag-handle",
                                        style: { cursor: "move" },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v(" menu ")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("switchable-input", {
                                      attrs: {
                                        "title-text": document.title,
                                        "no-margin": "",
                                        placeholder: _vm.$t(
                                          "documents.writeNewTitleHere"
                                        ),
                                      },
                                      on: {
                                        save: function (data) {
                                          return _vm.handleSaveTitle(
                                            Object.assign({}, document, {
                                              title: data,
                                            })
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("editable-description", {
                                    attrs: {
                                      "no-margin": "",
                                      description: document.description,
                                    },
                                    on: {
                                      save: function (data) {
                                        return _vm.handleSaveDescription(
                                          Object.assign({}, document, data)
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "div",
                                  [
                                    _c("inline-prompt", {
                                      staticClass:
                                        "d-inline-block bold text-gray ml-2",
                                      attrs: {
                                        placement: "left",
                                        "action-type": "delete",
                                        "confirmation-text": _vm.$t(
                                          "documents.deleteDocumentTypeConfirmation"
                                        ),
                                      },
                                      on: {
                                        accept: function ($event) {
                                          return _vm.handleRemove(document)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ])
              : _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column align-items-center w-100",
                  },
                  [
                    _c(
                      "no-results",
                      {
                        attrs: {
                          "img-src": require("@Shared/@Assets/img/application-missing.png"),
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "documents.thereAreCurrentlyNoDocumentTypes"
                              )
                            ) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function (ref) {
          var close = ref.close
          return [
            _c(
              "b-row",
              {
                staticClass:
                  "py-3 align-items-center justify-content-between w-100",
              },
              [
                _c(
                  "b-col",
                  { staticClass: "vertical-center" },
                  [
                    _c("material-input", {
                      staticClass: "w-40 mb-0 mr-3",
                      attrs: {
                        value: _vm.newDocumentTitle,
                        label: _vm.$t("documents.documentTypeTitle"),
                        "on-type": "",
                      },
                      on: { enter: _vm.handleCreateDocumentType },
                      model: {
                        value: _vm.newDocumentTitle,
                        callback: function ($$v) {
                          _vm.newDocumentTitle = $$v
                        },
                        expression: "newDocumentTitle",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "simple-button",
                      {
                        attrs: {
                          type: "primary btn-sm",
                          disabled: !_vm.newDocumentTitle,
                          loading: _vm.creating,
                          "loading-succeeded": _vm.creatingStatus,
                        },
                        on: { click: _vm.handleCreateDocumentType },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("global.words.add")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "auto" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-sm",
                        attrs: { variant: "white" },
                        on: {
                          click: function ($event) {
                            return close()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("global.words.close")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }